import React from "react";
import { Icon } from "@clarkinc/zest-design-system";
import spritePath from "~/common/Icons/Zest/remixicon.symbol.v1.svg";

interface AiReviewSummaryProps {
  reviewWords: string[];
  hasReviewWords: boolean;
  summaryText: string;
  isProductReviewPage?: boolean;
}

const AiReviewSummary = ({
  reviewWords,
  hasReviewWords,
  summaryText,
  isProductReviewPage,
}: AiReviewSummaryProps) => {
  let containerClass = "review-keyword-section xxxsl:flex px-6";

  if (isProductReviewPage) {
    containerClass += " xl:w-1/2 xl:border-t-0 xxxsl:flex-col border-t py-6";
  } else {
    containerClass +=
      " xxxsl:w-1/2 xxxsl:flex-col xxxsl:py-0 xxxsl:pl-8 xxxsl:pr-0 py-8 px-10";
  }

  return (
    <div className={containerClass}>
      <div className="flex items-center mb-4">
        <Icon
          className="w-4 h-4 mr-1 fill-green-500"
          size="2xsmall"
          name="ri-sparkling-fill"
          spriteSheetHref={spritePath}
        />
        <h3 className="text-xl leading-none m-0">Customers Say</h3>
      </div>
      <div>
        <p className="text-left text-base">{summaryText}</p>
        {hasReviewWords ? (
          <ul className="flex flex-wrap list-none m-0">
            {reviewWords.map((tag) => (
              <li
                key={tag}
                className="text-xs font-bold py-0.5 px-2 bg-green-50 rounded m-0 mr-2 mb-2.5"
              >
                {tag}
              </li>
            ))}
          </ul>
        ) : null}
      </div>
      <p className="text-gray-600 text-sm text-left pt-1.5 m-0">
        This AI-generated summary was created from real customer reviews
      </p>
    </div>
  );
};

export default AiReviewSummary;
